import { render, staticRenderFns } from "./VueAwesomeSwiper.vue?vue&type=template&id=75d9bcb3&scoped=true"
import script from "./VueAwesomeSwiper.vue?vue&type=script&lang=js"
export * from "./VueAwesomeSwiper.vue?vue&type=script&lang=js"
import style0 from "./VueAwesomeSwiper.vue?vue&type=style&index=0&id=75d9bcb3&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d9bcb3",
  null
  
)

export default component.exports